<div class="landings-bookyup-system">

  <!-- header start here -->
  <header id="about-us-header-section">
    <nav class="navbar navbar-expand-lg">
      <div class="container">
        <a class="navbar-brand" href="#">
          <img src="../../assets/images/home-new-static/header/logo-header.png" alt="">
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link" aria-current="page" href="/">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link active" href="/about-us#about-us-header-section">About Us</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://career.bookyup.co.uk/" target="_blank">Career</a>
            </li>
          </ul>

          <div class="button-div">
            <a class="book-btn" href="/home#contact-form-main">
              Become a partner
            </a>
          </div>
        </div>
      </div>
    </nav>
  </header>
  <!-- header start here -->

  <!-- about banner start here -->
  <section data-aos="zoom-in" id="about-us-banner-section">
    <div class="about-banner">
      <div class="row">
        <div class="col-lg-12">
          <h1>About Us</h1>
          <p>Your restaurant's growth partner — for smarter, faster online success.</p>
        </div>
      </div>
    </div>
  </section>
  <!-- about banner end here -->

  <section class="our-journey">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 " id="second-order" data-aos="fade-right">
          <h3 class="mb-2">Our Journey So Far</h3>
          <p>We founded Bookyup in 2017 with a simple, yet powerful idea: to create restaurant-centric marketing that
            puts the focus where it belongs—on the restaurant itself. By highlighting the food and experience, we ensure
            that customers remember the restaurant, not the marketing company behind it.
            <br>
            Our approach has always been about authenticity and growth. We’ve empowered countless restaurants and
            takeaways to thrive locally, attracting the right customers who share a love for their unique cuisines.
            Through restaurant-centric marketing, we’ve helped these businesses become local legends.
          </p>
        </div>
        <div class="col-lg-6" id="first-order" data-aos="fade-left">
          <img class="w-100" src="../../assets/images/home-new-static/aboutpage/About1.png" alt="">
        </div>
      </div>
    </div>
  </section>

  <section class="our-journey">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6" data-aos="fade-right">
          <img class="w-100" src="../../assets/images/home-new-static/aboutpage/About2.png" alt="">
        </div>
        <div class="col-lg-6" data-aos="fade-left">
          <h3 class="mb-2">Your Growth Is Our Mission</h3>
          <p>Our restaurant-centric marketing gives takeaways and restaurants the boost they need to thrive. We help
            them stay top-of-mind as the go-to spot in the UK.
            <br>
            With a mix of smart strategy and creative thinking, we fuel their digital growth. By promoting their food
            and service, we attract customers who keep coming back.
          </p>
        </div>
      </div>
    </div>
  </section>

  <section class="our-journey">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6" id="second-order" data-aos="fade-right">
          <h3 class="mb-2">Leading The Way Forward</h3>
          <p>Our vision is to become the go-to partner for local takeaway restaurants seeking growth and visibility.
            <br>
            We see the future as one where our tailored branding campaigns help restaurants connect with a wider
            audience.
          </p>
        </div>
        <div class="col-lg-6" id="first-order" data-aos="fade-left">
          <img class="w-100" src="../../assets/images/home-new-static/aboutpage/About3.png" alt="">
        </div>
      </div>
    </div>
  </section>

  <section class="our-journey">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6" data-aos="fade-right">
          <img class="w-100" src="../../assets/images/home-new-static/aboutpage/About4.png" alt="">
        </div>
        <div class="col-lg-6" data-aos="fade-left">
          <h3 class="mb-2">Marketing With Integrity</h3>
          <p>Our values shape everything we do at Bookyup, guiding us to be an online marketing company that truly
            cares. We believe in teamwork, where every idea matters and collaboration drives great results, making us
            stronger together.
            <br>
            We’re committed to always being transparent and honest with our clients, building relationships based on
            integrity.
          </p>
        </div>
      </div>
    </div>
  </section>


  <!-- contact upper footer start here -->
  <!-- <section class="contact-upper-footer" id="contact-form-main">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="text-div">
            <h3>Get in Touch with Us</h3>
            <p>Have a question or want to get started? Fill out the form below, and our team will be happy to assist you. We’re here to help your restaurant grow with the right marketing solutions.</p>
          </div>
        </div>
        <div class="col-lg-6" data-aos="zoom-in">
          <div class="form-div">
            <form action="" #cf="ngForm" (ngSubmit)="contactsubmit(cf.form.valid,cf)">
              <div class="form-group mb-2">
                <label for="exampleInputEmail1">Restaurant's Name <span>*</span></label>
                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                  placeholder="Restaurant's Name" [(ngModel)]="postbody.bs_name" name="bs_name" #bs_name="ngModel"
                  required>
                <div class="alert alert-danger"
                  *ngIf="(bs_name.invalid && bs_name.touched) || (bs_name.invalid && cf.submitted)">
                  Business name is required
                </div>
              </div>
              <div class="form-group mb-2">
                <label for="exampleInputEmail1">Restaurant's Address <span>*</span></label>
                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                  placeholder="Restaurant's Address" [(ngModel)]="postbody.bs_address" name="bs_address"
                  #bs_address="ngModel" required>
                <div class="alert alert-danger"
                  *ngIf="(bs_address.invalid && bs_address.touched) || (bs_address.invalid && cf.submitted)">
                  Address and postcode is required
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group mb-2">
                    <label for="exampleInputEmail1">Owner's First Name <span>*</span></label>
                    <input type="name" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                      placeholder="First Name" [(ngModel)]="postbody.fname" name="fname" #fname="ngModel" required>
                    <div class="alert alert-danger"
                      *ngIf="(fname.invalid && fname.touched) || (fname.invalid && cf.submitted)">
                      First name is required
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group mb-2">
                    <label for="exampleInputEmail1">Last Name <span>*</span></label>
                    <input type="name" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                      placeholder="Last Name" [(ngModel)]="postbody.lname" name="lname" #lname="ngModel" required>
                    <div class="alert alert-danger"
                      *ngIf="(lname.invalid && lname.touched) || (lname.invalid && cf.submitted)">
                      First name is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group mb-2">
                <label for="exampleInputEmail1">Email <span>*</span></label>
                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                  placeholder="Your email" [(ngModel)]="postbody.email" name="email" #email="ngModel" required>
                <div class="alert alert-danger"
                  *ngIf="(email.invalid && email.touched) || (email.invalid && cf.submitted)">
                  Email address is required
                </div>
              </div>
              <div class="form-group mb-2">
                <label for="exampleInputEmail1">Mobile No <span>*</span></label>
                <input type="text" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp"
                  placeholder="Your Mobile No" [(ngModel)]="postbody.mobile" name="mobile" #mobile="ngModel" required>
                <div class="alert alert-danger"
                  *ngIf="(mobile.invalid && mobile.touched) || (mobile.invalid && cf.submitted)">
                  Mobile number is required
                </div>
              </div>
              <div class="form-group mb-2">
                <label for="exampleFormControlTextarea1">Example textarea <span>*</span></label>
                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" [(ngModel)]="postbody.message"
                  name="msg" #msg="ngModel" required></textarea>
                <div class="alert alert-danger" *ngIf="(msg.invalid && msg.touched) || (msg.invalid && cf.submitted)">
                  Message is required
                </div>
              </div>
              <div class="form-check mb-4">
                <input type="checkbox" class="form-check-input" id="exampleCheck1">
                <label class="form-check-label" for="exampleCheck1">Check me out</label>
              </div>
              <div class="fldarea">
                <div #recaptcha></div>
              </div>
              <button type="submit" class="book-btn m-0">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section> -->
  <!-- contact upper footer end here -->


  <!-- footer start here -->
  <footer class="new_footer_area bg_color" data-aos="fade-up" data-aos-anchor-placement="center-bottom">
    <div class="new_footer_top">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6">
            <div class="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s"
              style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
              <a href="#">
                <img class="footer-logo-main" src="../../assets/images//home-new-static/header/logo-header.png" alt="">
              </a>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="f_widget about-widget pl_70 wow fadeInLeft" data-wow-delay="0.6s"
              style="visibility: visible; animation-delay: 0.6s; animation-name: fadeInLeft;">
              <h3 class="f-title f_600 t_color f_size_18">Links</h3>
              <ul class="list-unstyled f_list">
                <li><a  href="/home#home-page-banner-section">Home</a></li>
                <li><a href="/about-us#about-us-banner-section">About Us</a></li>
                <li><a href="https://career.bookyup.co.uk/" target="_blank">Career</a></li>
                <li><a href="/home#contact-form-main">Contact Us</a></li>
              </ul>
            </div>
          </div>
          <!-- <div class="col-lg-3 col-md-6">
            <div class="f_widget company_widget wow fadeInLeft" data-wow-delay="0.2s"
              style="visibility: visible; animation-delay: 0.2s; animation-name: fadeInLeft;">
              <h3 class="f-title f_600 t_color f_size_18">Get in Touch</h3>
              <p>Have a question or want to get started?</p>
              <form action="#" class="f_subscribe_two mailchimp" method="post" novalidate="true" _lpchecked="1">
                <input type="text" name="EMAIL" class="form-control memail" placeholder="Email">
                <button class="btn btn_get btn_get_two" type="submit">Subscribe</button>
                <p class="mchimp-errmessage" style="display: none;"></p>
                <p class="mchimp-sucmessage" style="display: none;"></p>
              </form>
            </div>
          </div> -->
          <div class="col-lg-3 col-md-6">
            <div class="f_widget social-widget pl_70 wow fadeInLeft" data-wow-delay="0.8s"
              style="visibility: visible; animation-delay: 0.8s; animation-name: fadeInLeft;">
              <h3 class="f-title f_600 t_color f_size_18">Follow Us</h3>
              <div class="f_social_icon">
                <a href="javascript:void(0)"><i class="fab fa-facebook"></i></a>
                <a href="javascript:void(0)"><i class="fa-brands fa-x-twitter"></i></a>
                <a href="javascript:void(0)"><i class="fab fa-linkedin"></i></a>
                <a href="javascript:void(0)"><i class="fa-brands fa-instagram"></i></a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer_bg">
        <div class="footer_bg_one"></div>
        <div class="footer_bg_two"></div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-12 col-sm-12">
            <p class="mb-0 f_400 text-center">© {{footerCopyrightYear}} All rights reserved.</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- footer end here -->




</div>